/**
 * ValuePropHero — first-fold one-liner on /dashboard
 *
 * Friendly, calm, and concrete. Not a wall of text and not a slogan;
 * something a CFO can read in 4 seconds.
 *
 * v35.40 — restyled for the light dashboard theme (theme-public-light was
 * flipping the old dark-card bg to white, leaving slate-50 text invisible).
 */
import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ValuePropHero({ name = '' }) {
  const greeting = name ? `Welcome back, ${name}.` : 'Welcome to CARTIE.';
  return (
    <div className="rounded-2xl bg-white ring-1 ring-emerald-200/80 shadow-sm p-6 sm:p-8 mb-6" data-testid="value-prop-hero">
      <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-[10px] font-mono uppercase tracking-widest mb-3">
        <Sparkles className="w-3 h-3" /> Your automated cloud cost engineer
      </div>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 leading-[1.1]" data-testid="value-prop-h1">
        {greeting}
        <br />
        Find cloud waste. <span className="text-emerald-600">Save on AI tokens.</span> Both, automatically.
      </h1>
      <p className="mt-3 text-sm sm:text-base text-slate-600 max-w-2xl leading-relaxed">
        CARTIE quietly watches your cloud + LLM spend, surfaces what&apos;s wasteful, and shows you exactly what to do next. No tickets, no spreadsheets — and nothing is ever changed in your account without you clicking through it.
      </p>
      <div className="mt-5 flex flex-wrap gap-3">
        <Link
          to="/idle-killer/connect"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-semibold text-sm transition-colors"
          data-testid="hero-cta-connect"
        >
          Connect AWS <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <Link
          to="/how-it-saves"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg ring-1 ring-emerald-300 text-emerald-700 hover:bg-emerald-50 text-sm transition-colors"
          data-testid="hero-cta-how"
        >
          How CARTIE saves you money
        </Link>
      </div>
    </div>
  );
}
